import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { LoadPagePanel } from '../../../../components';
import { useGetRetailOrder } from '../api/get-retail-order';
import { RefetchScope, RetailOrderContext } from '../context/RetailOrderContext';
import { RetailOrderContextType } from '../types/RetailOrderContextType';


export default function RetailOrderPage(props: React.PropsWithChildren<unknown>) {

	const params = useParams();
	const retailOrderID = parseInt(params.retailOrderID!);

	const [orderState, setOrderState] = useState<RetailOrderContextType>({} as RetailOrderContextType);
	const { data: roData, isLoading, refetch, isRefetching } = useGetRetailOrder(retailOrderID);
	const [refetchScope, setRefetchScope] = useState<RefetchScope | undefined>();

	// Clear context on order ID change 
	if (orderState.details && orderState.details.retailOrderID !== retailOrderID) {
		setOrderState({} as RetailOrderContextType);
	}

	useEffect(() => {
		if (roData) {
			switch (refetchScope) {
				case RefetchScope.Files:
					setOrderState({
						details: { ...orderState.details, files: roData.files }, originalDetails: roData,
						modified: orderState.modified
					});
					break;

				case RefetchScope.Notes:
					setOrderState({
						details: { ...orderState.details, notes: roData.notes }, originalDetails: roData,
						modified: orderState.modified
					});
					break;

				default:
					setOrderState({ details: roData, originalDetails: roData, modified: false });
					break;
			}
		}
	}, [roData]);

	return (
		<React.Fragment>
			{
				orderState.details &&
				<RetailOrderContext.Provider value={{
					order: orderState,
					modifyOrder: (details) => setOrderState(
						{ ...orderState, details: details, modified: true }),
					refetchOrder: (scope?: RefetchScope) => {
						setRefetchScope(scope);
						return refetch();
					}
				}}>

					<div className={'content-block order-page'}>
						{props.children}
					</div>
				</RetailOrderContext.Provider>
			}

			<LoadPagePanel visible={isLoading || isRefetching} />
		</React.Fragment>)
}
